import { useGetProgramsQuery } from 'Services/api/programApi';
import { useGetReportFormatsQuery } from 'Services/api/reportFormatsApi';
import React from 'react';
import { Pane, Table, Text } from 'evergreen-ui';
import { UTCtoTimeZone } from 'Utils/UTCConverter';
import SuspenseSpinner from 'Utils/SuspenseSpinner';
import MessagesPanel from 'Features/Stations/Station/Messages/Station.Messages.Panel';
import { CUT, MessagesTable } from 'Features/Stations/Station/Messages/messageUtils';
import { SourceInfo } from 'Shared/EventSourceInfo/SourceInfo';

export default function StationMessagesCut({ params, useGetMessages, useGetMessageFileQuery, useGetStatusQuery, isArchive, headersMessagesCut }) {
  const { isFetching: isLoadingPrograms } = useGetProgramsQuery();
  const { isFetching: isLoadingFormats } = useGetReportFormatsQuery();
  const [mode, setMode] = React.useState('table');

  const headers = React.useMemo(() => [
    { name: `Срок UTC${params.timeZone}`, cellProps: {} },
    { name: `Время создания UTC${params.timeZone}`, cellProps: {} },
    { name: 'Формат', cellProps: {} },
    { name: 'Программа', cellProps: {} },
    { name: 'Статус', cellProps: {} },
  ], [params.timeZone]);

  const toggleView = React.useCallback(() => {
    setMode((cur) => (cur === 'table' ? 'card' : 'table'));
  }, []);

  const RowCells = React.useCallback(({ message, timeZone }) => {
    const {
      status, dateTime, createDateTime, program, format: messageFormat, datasource,
    } = message;
    return (
      <>
        <Table.Cell flex={isArchive ? '1 0' : '1'}>
          <Text>{dateTime ? UTCtoTimeZone(dateTime, timeZone) : 'нет срока'}</Text>
        </Table.Cell>
        <Table.Cell flex={isArchive ? '1 0' : '1'}>
          <Text>{createDateTime ? UTCtoTimeZone(createDateTime, timeZone) : 'нет даты'}</Text>
        </Table.Cell>
        <Table.Cell flex={isArchive ? '0 1 10%' : '1'}>
          <Text>{messageFormat?.description || messageFormat?.code}</Text>
        </Table.Cell>
        <Table.Cell flex={isArchive ? '1 0' : '1'}>
          <Text>{program?.name}</Text>
        </Table.Cell>
        <Table.Cell flex={isArchive ? '1 0' : '1'}>
          <Text>{status?.status}</Text>
        </Table.Cell>
        {
          isArchive && (
            <Table.Cell>
              {datasource?.id
                ? <SourceInfo datasourceId={datasource.id} />
                : <Text>{'Источник не определён'}</Text>}
            </Table.Cell>
          )
        }
      </>
    );
  }, [isArchive]);

  if (isLoadingPrograms || isLoadingFormats) return <SuspenseSpinner />;

  return (
    <Pane display="grid" gridTemplateRows="max-content 1fr" padding=".5rem" rowGap=".5rem" overflow="hidden">
      <MessagesPanel
        params={params}
        type={CUT}
        toggleView={toggleView}
        useGetStatusQuery={useGetStatusQuery}
        isArchive={isArchive}
        useGetMessages={useGetMessages}
      />
      <MessagesTable
        type={CUT}
        params={params}
        mode={mode}
        headers={!isArchive ? headers : headersMessagesCut}
        RowCells={RowCells}
        useGetMessages={useGetMessages}
        useGetMessageFileQuery={useGetMessageFileQuery}
      />
    </Pane>
  );
}
